export class SettingsAddressSearchRequest {
    term = '';
    userId = '';
    accountId = '';
    pageNum: number;
    pageSize: number;

    constructor(
        accountId = '',
        userId = '',
        term = '',
        pageNum = 1,
        pageSize = 10
    ) {
        this.accountId = accountId;
        this.userId = userId;
        this.term = term;
        this.pageNum = pageNum;
        this.pageSize = pageSize;
    }
}
